import type { Input } from './input.interface';

export interface cv_DosingTable {
    C_DosingTable_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    DosingTable: string;
    ElementID: string;
    Input: Input[];
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
